<template>
    <main>
        <div
            class="graphics-box graphics-box--01 rellax"
            data-rellax-speed="2"
        ></div>
        <div
            class="graphics-box graphics-box--02 rellax"
            data-rellax-speed="2"
        ></div>
        <div
            class="graphics-box graphics-box--03 rellax"
            data-rellax-speed="2"
        ></div>
        <div
            class="graphics-box graphics-box--04 rellax"
            data-rellax-speed="2"
        ></div>
        <div class="container-blog">
            <div class="blog-header">
                <div class="blog-date">{{ currentarticel.datum }}</div>
                <h1 class="blog-title">{{ currentarticel.nazov }}</h1>
            </div>
            <div class="blog-cover">
                <img
                    :src="currentarticel.obrazok"
                    :alt="currentarticel.nazov"
                />
            </div>
            <article v-html="currentarticel.obsah"></article>
        </div>
        <section v-if="articles.length > 0" class="blog-offer">
            <div class="container-blog">
                <h2 class="section-title">
                    {{ $t("other_woutlog.blog_text_3") }}
                </h2>
                <div class="blog-list">
                    <blog-card
                        v-for="article in articles"
                        :key="article.id"
                        :article="article"
                    />
                </div>
            </div>
        </section>
    </main>
</template>

<script>
import BlogCard from "./BlogCard.vue";
export default {
    props: ["currentarticel", "articles"],
    components: { BlogCard },
};
</script>

<style lang="scss" scoped>
article {
    margin-bottom: 100px;
}
</style>
